import { findPathApi } from '@/store/api/home';

export default {
    data() {
        return {
            orgId: '',
            organizationName: ''
        };
    },
    methods: {
        visibleChange(id) {
            if (this.orgId !== id) {
                this.organizationName = '';
                this.orgId = id;
                if (!id) return;
                findPathApi(id).then((res) => {
                    this.organizationName = res.data.organizationName;
                });
            }
        },
        // intTextMouse(id) {
        //     console.log(id);
        //     if (this.orgId !== id) {
        //         this.organizationName = '';
        //         this.orgId = id;
        //         if (!id) return;
        //         findPathApi(id).then((res) => {
        //             this.organizationName = res.data.organizationName;
        //         });
        //     }
        // },
    },
    computed: {
        organizationNameFun() {
            return this.organizationName;
        }
    },
};
